import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { M8UserFullInfo } from 'services/production/types';

export const getUser = async (userId: number): Promise<M8UserFullInfo> => {
  const response = await customFetch(getM8AdminURL(`getUser?idUser=${userId}`));

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
